import React from 'react';
import PropTypes from 'prop-types';
import { MdDone } from 'react-icons/lib/md';
import { connect } from 'react-redux';

import { formatDate } from '../../utils/';
import { fetchbPkgStList } from '../../actions/project_actions';

class BidPkgViewForm extends React.Component {
    // static PropTypes = {
    //     bidPackage: PropTypes.object.isRequired,
    // }

    constructor(props) {
        super(props);

        this.renderSelectFieldTable = this.renderSelectFieldTable.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.fetchbPkgStList();
    }

    renderSelectFieldTable(chkListLabelId) {

        var chkLstLabels = this.props.bidPkgCheckListStatuses.filter(c => c.chkListLabelId === chkListLabelId);

        if (chkLstLabels.length > 0 && this.props.bidPkgCheckListStatuses.length > 0) {
            var ind = this.props.bidPkgCheckListStatuses.findIndex(c => c.chkListLabelId === chkListLabelId);

            var chkValue = this.props.bPkgStList.filter(c => c.chkListLabelId === chkListLabelId 
                                                        && c.chkListStatusId === this.props.bidPkgCheckListStatuses[ind].chkListStatusId);

            return (
                <p>{chkValue.length > 0 && chkValue[0].chkListStatusName}</p>
            );
        }
        else
            return null;
    }

    render() {
        const { bidPackage, bidPkgCheckListStatuses } = this.props;

        return (

            <div>
                <div className="col s12">

                    <div className="row">
                        <div className="col l4 m4 s12">
                            <div className="controls">
                                <span className="label span-inline">Received Bid Package:</span>
                                <span className="value span-inline">
                                    {bidPackage.rcvdBidPkg ? 'Yes'
                                        : 'No'}
                                </span>
                            </div>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col l4 m4 s12">
                            <div className="controls">
                                <span className="label">Bid Package Status:</span>
                                {bidPackage.statusId === 1
                                    ? <span className="value">In Progress</span>
                                    : null}
                                {bidPackage.statusId === 3
                                    ? <span className="value">Approved</span>
                                    : null}
                                {bidPackage.statusId === 2
                                    ? <span className="value">Returned</span>
                                    : null}
                            </div>
                        </div>

                        <div className="col l4 m4 s12">
                            <div className="controls">
                                <span className="label">Date submitted:</span>
                                <span className="value">{formatDate(bidPackage.submittedDate)}</span>
                            </div>
                        </div>

                        {bidPackage.statusId === 3
                            ? <div className="col l4 m4 s12">
                                <div className="controls">
                                    <span className="label">Date approved:</span>
                                    <span className="value">{formatDate(bidPackage.approvedDate)}</span>
                                </div>
                            </div>
                            : null}

                        {bidPackage.statusId === 2
                            ? <div className="col l4 m4 s12">
                                <div className="controls">
                                    <span className="label">Date returned:</span>
                                    <span className="value">{formatDate(bidPackage.returnedDate)}</span>
                                </div>
                            </div>
                            : null}
                    </div>

                    <div className="row">
                        <div className="col l12 m12 s12">
                            <div className="controls">
                                <span className="label">Comments:</span>
                                <span className="value">{bidPackage.comment}</span>
                            </div>
                        </div>
                    </div>

                </div>

                {/* <div id="bidPackageCheckList">   // Disable checklist

                    <div className="col s12">
                        <div className="sub-heading">
                            <h6>Checklist</h6>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <label>Document name</label>
                        </div>
                        <div className="col l3 m3 s6">
                            <label>Required/Not required</label>
                        </div>
                        <div className="col l3 m3 s6">
                            <label>Submitted/Not submitted</label>
                        </div>
                        <div className="col l3 m3 s6">
                            <label>Approved/Returned</label>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>Accessibility Form</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(15)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>ACCO Flow CSB Sheet with PIN number</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(13)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>Addendum to General Conditions: word</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(5)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[41].chkListStatusId === 9
                                && this.renderSelectFieldTable(6)}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>APT E-Pin number (by BP)</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(14)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s12">
                            <p>Asbestos abatement and/or incidental specifications: pdf</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(9)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[37].chkListStatusId === 17
                                && this.renderSelectFieldTable(10)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Bid alternate approval</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(30)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[17].chkListStatusId === 59
                                && this.renderSelectFieldTable(45)}
                        </div>
                        <div className="col l3 m3 s6">

                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Bid Package Checklist: pdf</p>
                        </div>
                        <div className="col l3 m3 s6">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(32)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Bid Submission Form: pdf</p>
                        </div>
                        <div className="col l3 m3 s6">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(31)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s12">
                            <p>Commissioning Agent specifications</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(11)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[35].chkListStatusId === 21
                                ? this.renderSelectFieldTable(12)
                                : null}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>Constructability Sign Off of Drawings</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(18)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>Consultant’s Cost Estimate: excel</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(3)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[43].chkListStatusId === 5
                                ? this.renderSelectFieldTable(4)
                                : null}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Feasibility Study approval – for New Construction projects</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(22)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[25].chkListStatusId === 43
                                ? this.renderSelectFieldTable(37)
                                : null}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Federal Contract Documents</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(21)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[26].chkListStatusId === 41
                                ? this.renderSelectFieldTable(36)
                                : null}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Geotechnical Report</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(20)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[27].chkListStatusId === 39
                                ? this.renderSelectFieldTable(35)
                                : null}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>MWBE Schedule B (by BP)</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(17)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>MWBE worksheet completed</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(16)}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>PQL approval</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(24)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[23].chkListStatusId === 47
                                ? this.renderSelectFieldTable(39)
                                : null}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Proprietary items approval: signed memo</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(46)}
                        </div>
                        <div className="col l3 m3 s6">

                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[1].chkListStatusId === 91
                                ? this.renderSelectFieldTable(47)
                                : null}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Proprietary items justification</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(28)}
                        </div>
                        <div className="col l3 m3 s6">

                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[19].chkListStatusId === 55
                                ? this.renderSelectFieldTable(43)
                                : null}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Proprietary items list of costs</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(29)}
                        </div>
                        <div className="col l3 m3 s6">

                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[18].chkListStatusId === 57
                                ? this.renderSelectFieldTable(44)
                                : null}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Special Experience approval</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(27)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[20].chkListStatusId === 53
                                ? this.renderSelectFieldTable(42)
                                : null}
                        </div>
                        <div className="col l3 m3">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Special Experience Bid Booklet Page (by BP)</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(26)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[21].chkListStatusId === 51
                                ? this.renderSelectFieldTable(41)
                                : null}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Special Experience Justification</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(25)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[22].chkListStatusId === 49
                                ? this.renderSelectFieldTable(40)
                                : null}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>Specifications: combined pdf</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(1)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[45].chkListStatusId === 1
                                ? this.renderSelectFieldTable(2)
                                : null}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>Specifications: printed double sided, unbound</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(33)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[14].chkListStatusId === 65
                                ? this.renderSelectFieldTable(34)
                                : null}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s8">
                            <p>Table of Contents: word</p>
                        </div>
                        <div className="col l3 m3 s4">
                            <p><MdDone size={20} color="#008000" /></p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(7)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[39].chkListStatusId === 13
                                ? this.renderSelectFieldTable(8)
                                : null}
                        </div>
                    </div>

                    <div className="row">
                        <div className="col l3 m3 s6">
                            <p>Unit Price Schedule</p>
                        </div>
                        <div className="col l3 m3 s6">
                            {this.renderSelectFieldTable(23)}
                        </div>
                        <div className="col l3 m3 s6">
                            {bidPkgCheckListStatuses.length > 0 && bidPkgCheckListStatuses[24].chkListStatusId === 45
                                ? this.renderSelectFieldTable(38)
                                : null}
                        </div>
                        <div className="col l3 m3 s6">
                        </div>
                    </div>

                </div> */}

            </div>

        )
    }
}

BidPkgViewForm.propTypes = {
    bidPackage: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        bPkgStList: state.projectsStore.bPkgStList,
    }
}

export default connect(mapStateToProps, {
    fetchbPkgStList,
})(BidPkgViewForm);